import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function BreakfastPage() {

    const heroData = [
        {
          title: "Breakfast",
          content: "Start your day right with our wholesome and delicious breakfast options, made fresh to fuel your morning.",
          image: images.BreakfastHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Morning Harmony",
        content: "A freshly brewed coffee, a glass of fresh orange juice, a buttery viennoiserie, a baguette, creamy butter, and jam",
        price: 0,
        image: [
          images.Breakfast1,
        ]
      },
      {
        name: "Signature Breakfast",
        content: "A freshly brewed coffee, a glass of fresh orange juice, a buttery viennoiserie, a baguette, creamy butter, jam, eggs cooked to your preference",
        price: 0,
        image: [
          images.Breakfast2,
        ]
      },
      {
        name: "Avocado Toast",
        content: "Scrambled eggs, mashed avocados, and feta cheese on a sourdough bread served with crisp side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast3,
        ]
      },
      {
        name: "Healthy Breakfast",
        content: "Egg white scramble, avocado, served with side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast1,
        ]
      },
      {
        name: "Egg Benedict",
        content: "Two poached eggs on a croissant with hollandaise sauce, rocket leaves, smoked salmon or turkey breast with side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast2,
        ]
      },
      {
        name: "Sunrise Croissant",
        content: "Buttery croissant filled with rocket leaves and cheesy scrambled eggs with side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast3,
        ]
      },
      {
        name: "Turkey & Cheese Croissant",
        content: "Turkey breast and gouda cheese in a buttery croissant with side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast1,
        ]
      },
      {
        name: "Smoked Salmon Quiche",
        content: "Savory tart filled with egg custard and smoked salmon with side salad or fruit salad",
        price: 0,
        image: [
          images.Breakfast2,
        ]
      },
      {
        name: "Granola Bowl",
        content: "Homemade granola with yogurt and fresh berries",
        price: 0,
        image: [
          images.Breakfast3,
        ]
      },
      {
        name: "Belgium Waffle",
        content: "Served with your choice of toppings: maple syrup, fresh berries, whipped cream, chocolate drizzle, pistachio sauce, lotus sauce or Nutella",
        price: 0,
        image: [
          images.Breakfast1,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Signature Breakfast",
        image1: [
          images.Breakfast2,
        ],
        content1: "A freshly brewed coffee, a glass of fresh orange juice, a buttery viennoiserie, a baguette, creamy butter, jam, eggs cooked to your preference",
        name2: "Avocado Toast",
        image2: [
          images.Breakfast3,
        ],
        content2: "Scrambled eggs, mashed avocados, and feta cheese on a sourdough bread served with crisp side salad or fruit salad"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
